var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"float-right d-none d-sm-inline"}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.stringWithCurrentYear)}})])}
var staticRenderFns = []

export { render, staticRenderFns }